export const OPEN_SPECIAL_SSR_MODAL = 'OPEN_SPECIAL_SSR_MODAL'

export default () => ({
  type: OPEN_SPECIAL_SSR_MODAL,
})
